import {Component, Input} from '@angular/core';
import {MatCard, MatCardContent, MatCardSubtitle} from "@angular/material/card";
import {MatIcon} from "@angular/material/icon";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-click-card',
  imports: [
    MatCardContent,
    MatCard,
    MatIcon,
    MatCardSubtitle,
    RouterLink
  ],
  templateUrl: './click-card.component.html',
  styleUrl: './click-card.component.scss'
})
export class ClickCardComponent {
  @Input() link: string = '';
  @Input() text: string = '';
  @Input() icon: string = '';
}
